import "../../../Index.scss";
import DocumentIntro from "../DocumentIntro/DocumentIntro";

export const ResearchSearchResult = ({researchItem, index, onClickPreview, onClickTLDReadMore, onClickReadMore, getQuikInfoData}:any) => {
  return (
      <div className="group-list" key={`ResearchSearchResult${index}`}>
            <div className="group-list-head">
                <span className="group-list-title">
                    <ul className="group-list-places">
                        <li>
                            {" "}
                            <img
                                className="group-list-icon logoicon"
                                src={'https://cdn.taxmann.com/taxmann-images/taxmann-premium/research-icon-n1.png'}
                            ></img>{" "}
                        </li>
                        <li> {researchItem.Index}{" "}</li>
                        <li> <i className="pi pi-angle-right"></i> </li>
                        <li>  {researchItem?.categoryName}  </li>
                        <li> <i className="pi pi-angle-right"></i> </li>
                        <li>  {researchItem?.groupName} </li>
                    </ul>
                </span>
                {(researchItem.groupUrl === 'caselaws' && researchItem.docIntro?.length) &&
                    <DocumentIntro item={researchItem} index={index} getQuikInfoData={getQuikInfoData} />
                }
            </div>
            <div className="group-list-contents">
                <div className="group-row">
                    <div className="list-items">
                        <div className="list-item-contents">
                            <h2 className="list-item-h2 pointer" onClick={() => onClickPreview(researchItem)}>
                                {" "}
                                {researchItem?.secondLine}
                                {/* {researchItem.secondLine} */}                           
                                </h2>
                            {researchItem?.groupUrl === 'caselaws' && researchItem?.thirdLine?.length ? (
                                <span className="list-item-description pointer">
                                    {" "}
                                    {researchItem?.shortTldData || researchItem?.thirdLine}
                                    {researchItem?.showTLDReadMore ? (
                                        <a  className="button-links cursor-pointer" onClick={() => onClickTLDReadMore(researchItem, index)}>
                                            Read More
                                        </a>
                                    ) : (
                                        researchItem.thirdLine?.length > 330 && (
                                            <a style={{marginLeft:'10px'}} className="button-links cursor-pointer" onClick={() => onClickTLDReadMore(researchItem, index)}>
                                                Read Less
                                            </a>
                                        )
                                    )}
                                </span>
                            ) : (
                                <span className="list-item-description pointer">
                                    {researchItem?.shortIntroduction || researchItem?.thirdLine}
                                    {researchItem?.showReadMore ? (
                                        <a  className="button-links cursor-pointer" onClick={() => onClickReadMore(researchItem, index)}>
                                            Read More
                                        </a>
                                    ) : (
                                        researchItem.shortIntroduction?.length > 330 && (
                                            <a  style={{marginLeft:'10px'}} className="button-links cursor-pointer" onClick={() => onClickReadMore(researchItem, index)}>
                                                Read Less
                                            </a>
                                        )
                                    )}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResearchSearchResult


 